'use client'
import Stack from '@mui/material/Stack'
import { FC } from 'react'

import Pill from '@/components/Pill'

const FortoCaseStudyStats: FC<{}> = () => {
    return (
        <Stack
            direction={{
                xs: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
            }}
            spacing={{
                xs: 1,
                sm: 1,
                md: 3,
                lg: 3,
                xl: 3,
            }}
        >
            <Pill
                header={'CUSTOMERS TAKING CLIMATE ACTION'}
                title={'60%'}
                // We are re-using the Logixboard image intentionally here, this is not a typo
                backgroundImageSrc={'/images/logixboard-case-study/logixboard-stat-adoption.png'}
            />
            <Pill
                header={'USAGE'}
                title={'3+ million shipments'}
                backgroundImageSrc={'/images/forto-case-study/forto-stat-2.png'}
            />
        </Stack>
    )
}

export default FortoCaseStudyStats
